import React from "react";
import "./ProLoc.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";

class ProLoc extends React.Component {
    render() {
        return(
            <div>
                <Nav/>
                 <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Project">01 Master Plan</a></p>
              <p className="ab">Planning Structure</p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/PlanningFeatures">Planning Features</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Intro"> 02 Project Introduction</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProLoc">04 Project Location</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoVision">05 Eco-Vision</a></p>

            </div>
          </div>
        <div className="col-8">
        <div class="abhead6">
        <p></p>
        </div>
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Project Location</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>At the Heart of the Global Circular Economy</p>
        <p className="text-justify">The Good Morning Bamboo Eco-City is strategically located within the Abura Asebu Kwamankese and Mfantsiman Districts Area in the Central Region which is by the economically thriving regions (The Central Region is bordered by the Ashanti and Eastern regions to the north, Western to the west, Greater Accra to the East and to the south by the Gulf of Guinea). This is selected being conscious of the fact that government of Ghana’s agenda for economic growth and job creation is underpinned by rapid and aggressive industrialization and value addition (especially in agro-processing and vibrant manufacturing) and integrated development of all the regions. Making Ghana the most business-friendly nation in Africa to accelerate enviro-socio-economic development and prosperity for all.<br/><br/>The Eco-City is highly accessible from key cities and industrial districts in the region via major highways and railways. It is located just 127km; 61km; 181km and 186km away from the bustling city centers of Accra, Takoradi, Kumasi and Koforidua respectively, while the highly developed University of Cape Coast (UCC) is only 27km away.

</p>
<div className="row">
<div className="col-6">
    <img style={{width: '100%', height: '100%'}} src="https://i.imgur.com/g7MA8Kt.jpg" alt="..."/>
</div>
<div className="col-6">
    <img style={{width: '100%', height: '100%'}} src="https://i.imgur.com/1nGGfEC.jpg" alt="..."/>
</div>
</div>
        </div>
       
      
     </div>
   </div>
            </div>
        )
    }
}
export default withRouter(ProLoc);